import React from "react";
import { Link } from "react-router-dom";
import { mediaUrl, formatQuarter } from "@/lib/api";
import { Overline } from "@/components/site/Primitives";

export function ArticleCard({ article, className = "" }) {
  return (
    <Link
      to={`/articles/${article.slug}`}
      className={`group block ${className}`}
      data-testid={`article-card-${article.slug}`}
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-cream-200">
        {article.featured_image ? (
          <img
            src={mediaUrl(article.featured_image)}
            alt={article.image_alt || article.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-ink to-steel-600">
            <span className="font-serif text-5xl text-gold-400/40">GF</span>
          </div>
        )}
      </div>
      <div className="pt-5">
        {article.category && <Overline>{article.category}</Overline>}
        <h3 className="mt-2 font-serif text-2xl font-normal leading-snug text-ink transition-colors group-hover:text-gold-600">
          {article.title}
        </h3>
        {article.excerpt && (
          <p className="mt-2 font-sans text-sm leading-relaxed text-steel-600 line-clamp-2">{article.excerpt}</p>
        )}
        <p className="mt-3 font-sans text-xs tracking-wide text-steel-400">
          {article.author} · {formatQuarter(article.published_at)} · {article.reading_time} min read
        </p>
      </div>
    </Link>
  );
}
